import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage } from "react-intl";
import ReactPhoneInput from "react-phone-input-2";
import Select from "react-select";
import moment from "moment";
import { instance } from "../../../../Actions/AxiosInstance";
import {
  ValidateAction,
  ValidateList,
  ValidateReqField,
  ValidateReqFields,
  ValidateSearchDropdown,
} from "../../../../Utils/Validation";
import { CustomForm } from "../../../../Assets/Js/CustomForm";
import createstore from "../../../../store";
import { getEJ2CalenderDateFormat, getFormattedDate } from "../../../../Utils";
import { DatePickerComponent } from "../../../../Component/Custom";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
});

class EmpImportantDateForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: 0,
      maxDate: new Date(),
      data: this.props.data,
      // relationshipTypes: this.props.relationshipTypes,
      fields: {
        firstname: "",
        lastname: "",
        contactnumber: "",
        dob: "",
        isemergency: false,
      },
      reqFields: {
        firstname: "",
        no: "",
        dob: "",
      },
      list: {
        relationshipid: "",
      },
      reqList: {
        relationshipid: "",
      },
      errors: {},
      helperText: {},
      relationshipTypes: [],
    };
    this.onCancel = this.onCancel.bind(this);
  }

  componentDidMount() {
    if (this.firstElement) this.firstElement.focus();
  }

  componentWillMount() {
    // this.props.ChangeLanguage("");
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    const { employeeid } = SubscriptionInfo.SubscriptionData;
    const DateFormat = get(
      SubscriptionInfo,
      "SubscriptionData.dateformatname",
      "",
    );

    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        DateFormat,
      },
      () => {
        this.GetRelationshipTypes();
      },
    );
  }

  GetRelationshipTypes() {
    instance
      .get("superuser/getmastercode/RelationshipType")
      .then((result) => {
        const relationshipTypes = [];
        // relationshipTypes.push(
        //   { displayname: "Select Dependent", displayvalue: "" },
        //   ...result.data.result
        // );
        // to load the relationshipTypes because that value is needed in this.GetPerticularDependentDetails()
        this.setState({ relationshipTypes: result.data.result }, () => {
          this.GetPerticularDependentDetails();
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetPerticularDependentDetails() {
    if (this.state.data) {
      const { data } = this.state;
      const { employeedependentid } = data;
      const fields = {
        firstname: data.firstname,
        lastname: data.lastname,
        contactnumber: data.contactnumber,
        no: data.contactnumber,
        dob: data.dob,
        isemergency: data.isemergency,
      };
      const reqFields = {
        firstname: data.firstname,
        no: data.contactnumber,
      };
      const list = {
        relationshipid: data.relationshipid,
      };
      const reqList = {
        relationshipid: data.relationshipid,
      };
      const selectedDependent = this.state.relationshipTypes.find(
        (x) => x.displayvalue == data.relationshipid,
      );
      this.setState({ selectedDependent });

      this.setState({
        fields,
        reqFields,
        list,
        reqList,
        employeedependentid,
      });
    }
  }

  Validate() {
    let formIsValid = true;

    if (!ValidateReqFields(this.state)) {
      formIsValid = false;
    }
    if (!ValidateList(this.state)) {
      formIsValid = false;
    }
    return formIsValid;
  }

  UpdateDependentsDetails() {
    if (!this.Validate()) {
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });
    } else {
      const data = {
        employeedependentid: this.state.employeedependentid,
        relationshipid: this.state.list.relationshipid,
        firstname: this.state.fields.firstname,
        lastname: this.state.fields.lastname,
        contactnumber: this.state.fields.contactnumber,
        dob: moment(this.state.fields.dob).format("YYYY-MM-DD"),
        isemergency: true,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
      if (!createstore.getState().AuthenticationAction.IsFulfilled) {
        Object.assign(data, {
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
          employeeid: this.props.colleagueid || this.state.employeeid,
        });
      }
      // this.setState({ data: data })
      instance
        .post("employee/insertupdateempdependent", data)
        .then((result) => {
          this.setState({
            relationshipid: "",
            firstname: "",
            lastname: "",
            contactnumber: "",
            dob: "",
            isemergency: false,
          });
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });

          const flag = 2;
          this.props.SetFlag(flag, true);
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  UpdateSelectedDropdownItem(name, HtField, selectedItem) {
    const { list } = this.state;
    const { reqList } = this.state;
    list[name] = selectedItem;
    list[name] = selectedItem.displayvalue ? selectedItem.displayvalue : "";

    this.setState({ list, name, selectedDependent: selectedItem });

    if (reqList[name] == "" || reqList[name] || reqList[name] == null) {
      reqList[name] = selectedItem.displayvalue
        ? selectedItem.displayvalue
        : "";
      this.setState({ reqList }, () => {
        this.ValidateEachDropDown(name);
      });
    }
  }

  ValidateEachDropDown(name) {
    ValidateSearchDropdown(this.state, name).then((result) => {
      this.setState({
        errors: result.errors,
      });
    });
  }

  ValidateOnNext(reqField, type) {
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    fields[field] = e.target.value ? e.target.value : "";
    this.setState({ fields }, () => {
      ValidateAction(this.state, field, type);
    });
  }

  ValidateField(reqField, type, e) {
    const { reqFields } = this.state;
    reqFields[reqField] = e.target.value ? e.target.value : "";
    this.setState({ reqFields });
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  OnPhoneChange(field, value) {
    this.state.fields.countryname = value.name;
    this.state.fields.callingcode = value.dialCode;
    this.state.fields.contactnumber = field;
    field = field.replace(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, "");
    const no = field.replace(value.dialCode, "");
    this.state.fields.no = no.trim();

    const { fields } = this.state;
    this.setState({ fields });
  }

  convertDate(str) {
    const date = new Date(str);
    const mnth = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  // selectDate(args) {
  //     let date = this.convertDate(args.value)
  //     let fields = this.state.fields;
  //     fields['dob'] = date;
  //     this.setState({ fields })
  // }

  selectDate = (a, args) => {
    console.log("a, args: ", a, args);
    const { fields } = this.state;
    if (args.value) {
      const date = args.value;
      // let date = this.convertDate(args.value)
      fields[a] = date;
    } else {
      fields[a] = null;
    }
    this.setState({ fields });
  };

  onCancel() {
    const flag = 2;
    this.props.SetFlag(flag, true);
  }

  render() {
    const dobValue = get(this.state, "fields.dob", null)
      ? new Date(get(this.state, "fields.dob", null))
      : null;
    return (
      // <div className='emp-from-wrapper imp-dates'>
      <div className="form-height ">
        <div id="div">
          <form
            className="custom-form-box profile-dependant"
            autoComplete="off"
          >
            <div className="inner-wrapper opaque" tabIndex="0">
              <div className="form-group" style={{ width: "70%" }}>
                <p className="active-color">
                  <FormattedMessage
                    id="LbDependents"
                    defaultMessage="Dependents"
                  />
                </p>
                <Select
                  ref={(r) => {
                    this.firstElement = r;
                  }}
                  id="relationshipId"
                  className="selectsearch2 Dependents1"
                  onChange={this.UpdateSelectedDropdownItem.bind(
                    this,
                    "relationshipid",
                    "HtSubscriptionType",
                  )}
                  options={this.state.relationshipTypes}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                  value={this.state.selectedDependent}
                  placeholder="Select relationship"
                  style={{ zIndex: "20", width: "200px !important" }}
                />
                <div>
                  {this.state.errors.relationshipid ? (
                    <span className="caption-error">
                      {" "}
                      <FormattedMessage
                        id="Errelationshipid"
                        defaultMessage="can not be empty"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="inner-wrapper opaque" tabIndex="1">
              <div className="form-group dependanr-form-group">
                {/* <p className="active-color"><span className="emp-special-head">Father Details, </span>To a father growing old nothing is dearer than his child</p> */}
                <p className="input-form-label">
                  <FormattedMessage
                    id="LbFirstName"
                    defaultMessage="First Name"
                  />
                </p>
                <div>
                  <TextField
                    className="firstname"
                    id="outlined-dense"
                    margin="dense"
                    variant="outlined"
                    placeholder="First Name"
                    onChange={this.OnFieldChange.bind(
                      this,
                      "firstname",
                      "name",
                    )}
                    onBlur={this.ValidateField.bind(this, "firstname", "name")}
                    // onBlur={this.ValidateField.bind(this, "firstname", "name")}
                    value={this.state.fields.firstname}
                    maxLength="40"
                  />

                  {/* <input className="input-area-section width100" type="text" placeholder="First Name"
                                            onChange={this.OnFieldChange.bind(this, "firstname", "name")}
                                            onBlur={this.ValidateField.bind(this, "firstname", "name")}
                                            value={this.state.fields.firstname}
                                            maxLength="40" /> */}
                </div>
                <div>
                  {this.state.errors.firstname ? (
                    <span className="caption-error">
                      {" "}
                      <FormattedMessage
                        id="Erfirstname"
                        defaultMessage="can not be empty"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="inner-wrapper opaque" tabIndex="2">
              <div className="form-group dependanr-form-group">
                <p className="input-form-label">
                  <FormattedMessage
                    id="LbLastName"
                    defaultMessage="Last Name"
                  />
                  <FormattedMessage
                    id="LbOptional"
                    defaultMessage="(Optional)"
                  />
                </p>
                <div>
                  <TextField
                    className="lastname"
                    id="outlined-dense"
                    margin="dense"
                    variant="outlined"
                    placeholder="Last Name"
                    onChange={this.OnFieldChange.bind(this, "lastname", "name")}
                    value={this.state.fields.lastname}
                    maxLength="40"
                  />

                  {/* <input className="input-area-section width100
                                        " type="text" placeholder="Last Name"
                                            onChange={this.OnFieldChange.bind(this, "lastname", "name")}
                                            value={this.state.fields.lastname}
                                            maxLength="40" /> */}
                </div>
                <div>
                  {this.state.errors.lastname ? (
                    <span className="caption-error">
                      {" "}
                      <FormattedMessage
                        id="Erlastname"
                        defaultMessage="can not be empty"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="inner-wrapper opaque" tabIndex="3">
              <div className="form-group dependent-phone-input">
                <div className="emp-from-landing emp-from-landing-1 ">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbEmergencyContactNumber"
                      defaultMessage="Emergency contact number"
                    />
                  </p>

                  <ReactPhoneInput
                    className="ContactTag"
                    defaultCountry={"in"}
                    countryCodeEditable={false}
                    // onFocus={this.SetHelperTextFlag.bind(this, "no")}
                    onChange={this.OnPhoneChange.bind(this)}
                    onBlur={this.ValidateField.bind(this, "no", "mobile")}
                    value={this.state.fields.contactnumber}
                    error={!!this.state.errors.no}
                    InputProps={{ maxLength: 15, minLength: 5 }}
                  />
                </div>
                <div>
                  {this.state.errors.no ? (
                    <span className="caption-error">
                      <FormattedMessage
                        id="ErMobileNo"
                        defaultMessage="can not be empty"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="inner-wrapper opaque" tabIndex="4">
              <div className="margin-bottom-20" style={{ width: 430 }}>
                <p className="input-form-label">
                  <FormattedMessage
                    id="LbBirthDate"
                    defaultMessage="Birth date"
                  />
                </p>

                <DatePickerComponent
                  className="Birth-Date"
                  placeholder="Birth Date"
                  // id="dob"
                  width="408"
                  start="Decade"
                  format={getEJ2CalenderDateFormat()}
                  // onClick={() => this.dateObj.show()}
                  // ref={(date)) => (this.dateObj = date)}
                  change={(e) => {
                    this.selectDate("dob", e);
                  }}
                  max={new Date()}
                  value={dobValue}
                  // value={null}
                  allowEdit={true}
                  // onBlur={this.ValidateField.bind(this, "dob", "")}
                />
              </div>
              {/* {!!this.state.errors["dob"] ? <span className="caption-error"> <FormattedMessage
                                    id="Erdob"
                                    defaultMessage="can not be empty"
                                /></span> : ''} */}
            </div>
            <div className="upform-footer">
              <Button
                className="Save"
                variant="contained"
                size="large"
                color="primary"
                class="form-btn form-control marginTop20"
                onClick={this.UpdateDependentsDetails.bind(this)}
              >
                <FormattedMessage id="BtSave" defaultMessage="Save" />
              </Button>
              <span className="margin-left-16" />
              <Button size="large" onClick={this.onCancel} className="Cancel">
                <FormattedMessage id="BtCancel" defaultMessage="Cancel" />
              </Button>
            </div>
          </form>
        </div>
      </div>
      // </div>
    );
  }
}

export default withSnackbar(EmpImportantDateForm);
